<app-header
    [clicked]="clickedOutside"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchedLanguage($event)"
></app-header>
<div class="page-content" (click)="closeMegaMenuCondition()">
    <img
        src="assets/images/icons/under-maintenance-icon.svg"
        alt="Under Maintenance Icon"
        class="icon"
    />
    <span class="title">
        {{ "UNDER_MAINTENANCE.TITLE" | translate }}
    </span>
    <span class="description">
        {{ "UNDER_MAINTENANCE.DESCRIPTION" | translate }}
    </span>
    <button class="button-home" (click)="onNavHome()">
        {{ "UNDER_MAINTENANCE.CTA" | translate }}
    </button>
</div>
<app-footer
    (click)="closeMegaMenuCondition()"
    [selectedLanguage]="languageSelected"
></app-footer>
